import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { apiSlice } from '../../api/apiSlice.js';
import { useGetCampaignData } from '../../hooks/useGetCampaignData.js';
import { useSetIsArchivedVersion } from '../../hooks/useIsArchivedVersion.js';
import { useSetSelectedBuyingPlanId } from '../../hooks/useSelectedBuyingPlanId.js';
import DndProvider from '../../organisms/DndProvider.jsx';
import PageSkeleton from '../../organisms/PageSkeleton/index.jsx';
import Builder from './Builder.jsx';

const PlanningPage = () => {
  const dispatch = useDispatch();
  const setSelectedPlanId = useSetSelectedBuyingPlanId();
  const setIsArchivedVersion = useSetIsArchivedVersion();
  const { isLoading: isCampaignLoading } = useGetCampaignData();

  useEffect(() => {
    return () => {
      dispatch(apiSlice.util.resetApiState());
      setSelectedPlanId(null);
      setIsArchivedVersion(false);
    };
  }, []);

  if (isCampaignLoading) {
    return <PageSkeleton />;
  }

  return (
    <DndProvider>
      <Builder />
    </DndProvider>
  );
};

export default PlanningPage;
